import React from "react";
import { useState } from "react";
import {
  Box,
  TextField,
  Button,
  CircularProgress,
  Typography,
  Alert,
  Stack,
} from "@mui/material";
import Dialogue from "./Dialogue";

const urlPrefix = "https://agent-dev.genaisolutions.ai";

export default function SimpleForm(props) {
  const [customerID, setCustomerID] = useState(
    props.data.customerID || ""
  ); /* Think this was for a future authenticated user ID...most stuff is anonymous */
  const [userId, setUserId] = useState(props.userId || "");
  const [table, setTable] = useState(props.data.table || "formAnswers");
  const [answer, setName] = useState("");
  const [question, setQuestion] = useState(props.data.question || "");
  const [formSaved, setFormSaved] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  //   console.log("form :: props ::", props);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (answer.length === 0) {
      return;
    }
    /* KAD took out Feb 17, 2025 because it wasn't working well
    var prompt = "does " + answer + " look like a good answer to \"" + question + "\". Please answer yes or no."
    const res = await llmCaller.sendPrompt({}, {}, prompt, 0.1);
    if (res && res.candidates.length > 0 && res.candidates[0].content.parts[0].text.substring(0,2) === 'No')
    {
       alert("That is not a valid answer to this question");
       return;
    }
*/
    setIsSubmitting(true);
    setErrorMessage("");
    let bodyData = {
      chatUserEmail: props.chatUserEmail || "",
      chatUserName: props.chatUserName || "",
      question: question,
      answer: answer,
      userId: userId,
      creationDate: new Date().toISOString(),
    };
    const url = urlPrefix + "/api/saveObject/" + table;
    try {
      const response = await fetch(url, {
        headers: { "Content-Type": "application/json" },
        method: "post",
        body: JSON.stringify(bodyData),
      });
      const data = await response.json();
      setIsSubmitting(false);
      if (data.success) {
        setFormSaved(true);
        if (props.callback) props.callback();
      } else {
        setErrorMessage("Failed to submit the form. Please try again.");
      }
    } catch (error) {
      setIsSubmitting(false);
      setErrorMessage(
        "An error occurred while submitting the form. Please try again."
      );
    }
  };

  return (
    <>
      <Box sx={{ mx: "auto", px: 3 }}>
        {formSaved === false && (
          <form onSubmit={handleSubmit}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography variant="h7" sx={{ color: props.textColor }}>
                Question: {question}
              </Typography>
              <TextField
                multiline
                rows={3}
                variant="outlined"
                value={answer}
                onChange={(e) => setName(e.target.value)}
                required
                fullWidth
                InputProps={{
                  sx: {
                    borderRadius: "12px",
                    color: "black",
                  },
                }}
              />
              {errorMessage && (
                <Alert severity="error" sx={{ width: "100%" }}>
                  {errorMessage}
                </Alert>
              )}
              <Button
                variant="contained"
                color="primary"
                size="medium"
                type="submit"
                disabled={isSubmitting}
                sx={{
                  width: "7rem",
                  fontFamily: "Google Sans",
                  textTransform: "none",
                  borderRadius: "12px",
                }}
              >
                {isSubmitting ? (
                  <CircularProgress size={20} color="#FFFFFF" />
                ) : (
                  "Submit"
                )}
              </Button>
            </Box>
          </form>
        )}
      </Box>
      {formSaved === true && (
        <>
          <Box
            sx={{
              width: "inherit",
              height: "inherit",
              marginTop: "15px",
            }}
          >
            <Stack width="100%" alignItems={"flex-start"}>
              <Dialogue
                style={{
                  overflow: "visible",
                  boxSizing: "border-box",
                  background: "#EDEDED",
                  borderRadius: "0px 20px 20px 20px",
                  padding: "10px 16px",
                  gap: "10px",
                  maxWidth: "85%",
                  fontSize: "16px",
                }}
              >
                <pre
                  style={{
                    wordBreak: "break-word",
                    whiteSpace: "pre-wrap",
                    width: "100%",
                    fontWeight: "lighter",
                    fontFamily: "inherit",
                    margin: 0,
                    color: "#292929",
                  }}
                >
                  {"Thank you for your response"}
                </pre>
              </Dialogue>
            </Stack>
          </Box>
        </>
      )}
    </>
  );
}
